<template>
  <v-app id="login" class="grey lighten-3">
    <v-container fill-height fluid>
      <v-row justify="center">
        <v-col cols="lg-6 md-6 sm-6 xs-12">
          <v-sheet class="pa-6">
            <v-container>
              <v-row>
                <v-col>
                  <div class="d-flex justify-center">
                    <v-img src="../assets/logo-wocodea.png" max-width="170px" alt="Wocodea Logo"></v-img>
                  </div>

                  <v-divider class="my-5"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h1 class="text-center display-6">Passwort zurücksetzen</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-alert v-model="alert" type="error" width="100%" class="mx-3" color="primary" dismissible>Email-Adresse nicht gefunden</v-alert>
                <v-alert v-model="success" type="success" width="100%" class="mx-3" color="success" dismissible
                  >Wir haben eine Email mit dem Link zum neu setzen des Passworts versendet.</v-alert
                >
              </v-row>
              <v-row>
                <v-col>
                  <v-form @submit.prevent="login">
                    <span class="body-2 font-weight-bold">Email</span>
                    <v-text-field
                      v-model="email"
                      dense
                      outlined
                      placeholder="email@address.com"
                      color="grey lighten-3"
                      :rules="[rules.required, rules.email]"
                    ></v-text-field>

                    <v-btn depressed color="primary" width="100%" type="submit">Passwort zurücksetzen</v-btn>

                    <v-divider class="my-5"></v-divider>
                    <div class="d-flex justify-center">
                      <router-link :to="{ name: 'login' }" class="body-2 grey--text text--darken-4">Zum Login</router-link>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
export default {
  data: () => ({
    show: false,
    email: "",
    password: "",
    rules: {
      required: (value) => !!value || "Pflichtfeld.",
      email: (v) => /.+@.+\..+/.test(v) || "Bitte gültige Email-Adresse eingeben",
    },
    alert: false,
    success: false,
  }),
  mounted() {
    this.alert = this.success = false;
  },
  methods: {
    async login() {
      const formData = new FormData();
      formData.append("client_id", process.env.VUE_APP_CLIENT_ID);
      formData.append("client_secret", process.env.VUE_APP_CLIENT_SECRET);
      formData.append("grant_type", "password");
      formData.append("email", this.email);
      formData.append("scope", "");

      this.$store
        .dispatch("reset_password", formData)
        .then(() => {
          this.alert = false;
          this.success = true;
        })
        .catch(() => {
          this.success = false;
          this.alert = true;
        });
    },
  },
};
</script>
